import { getHeaders } from "qpr-base/apicaller/api-caller";

import { DataReportRequest } from "./types";

export const saveBlob = (fileName: string, blob: Blob) => {
  // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
  const nav = window.navigator as any;
  if (nav && nav.msSaveOrOpenBlob) {
    nav.msSaveOrOpenBlob(blob);
    return;
  }

  // For other browsers: create a link pointing to the ObjectURL containing the blob.
  const objUrl = window.URL.createObjectURL(blob);

  let link = document.createElement("a");
  link.href = objUrl;
  link.download = fileName;
  link.click();

  // For Firefox it is necessary to delay revoking the ObjectURL.
  setTimeout(() => {
    window.URL.revokeObjectURL(objUrl);
  }, 250);
};

export const createReport = async (data: DataReportRequest) => {
  if (data.blob) return data.blob;

  const url = `${process.env.REACT_APP_SERVER_URL}/api/report/create`;
  console.log("Sending Report Request", data);

  // TODO: create a mapper which is generic here for the report data

  const dataToSend: DataReportRequest = {
    ...data,
    pages: (data.pages = data.pages.map((page) => {
      return {
        ...page,
        elements: page.elements.map((el) => {
          return {
            ...el,
            paragraphs: el.paragraphs?.map((para) => {
              return {
                ...para,
                fontName: "Helvetica Neue",
                portions: para.portions?.map((port) => {
                  return {
                    ...port,
                    fontName: "Helvetica Neue",
                  };
                }),
              };
            }),
          };
        }),
      };
    })),
  };

  const tryFetchingReport = async (retryCnt: number = 0): Promise<any> => {
    try {
      return await fetch(url, {
        method: "POST",
        credentials: "include",
        headers: getHeaders(undefined),
        body: JSON.stringify(dataToSend),
      });
    } catch (e) {
      if (retryCnt > 2) {
        return null;
      }
      return tryFetchingReport(retryCnt + 1);
    }
  };

  // try creating the report
  let res = await tryFetchingReport();

  let maxRetryCnt = 8;
  // Wait until the service becomes available again...
  while (res && res.status === 429 && maxRetryCnt > 0) {
    console.log("Printing service busy, trying again...");
    // eslint-disable-next-line
    await new Promise((res) => setTimeout(res, 3000 + Math.random() * 2000));
    // eslint-disable-next-line
    res = await tryFetchingReport();
    if (res === null) {
      throw new Error("Printing service not available");
    }
    maxRetryCnt -= 1;
  }

  if (res && res.status === 417) {
    // wait until restart
    await new Promise((res) => setTimeout(res, 2000));
    res = await tryFetchingReport();
    if (res === null) {
      throw new Error("Reporting service not available");
    }
  }

  if (res === null) {
    throw new Error("Reporting service not available");
  }

  const requestBlob = await res.blob();
  const type = res.headers.get("content-type")?.split(";")[0];
  const blob = new Blob([requestBlob], { type });

  return blob;
};
